export default "__VITE_ASSET__CQD5IXvu__"